

var _squid = require('squid');

require('./directive');

require('./xo-bml-apply/route');

require('./xo-bml-terms-and-conditions/route');

require('./xo-bml-signature/route');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BMLDisplay', function () {
    return _squid.$ComponentRoute.extend('BmlDisplay', {
        name: 'bmldisplay',
        directive: 'xo-bml-display',
        trackingData: {
            fptiState: 'ppc_display',
            buzname: {
                'fullpage': {
                    'pagename': '%::ppc_display',
                    'pagename2': '%::ppc_display:member:hermes:',
                    'version': 'member:%:'
                }
            }
        },
        titleContent: 'applyForBml.bmlApplyHeadline',
        children: [{
            name: '$BmlApplyRoute'
        }, {
            name: '$BmlTermsAndConditionsRoute'
        }, {
            name: '$BmlSignatureRoute'
        }]
    });
});

_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-credit-components/src/bml-display/route.js
// module id = ../node_modules/xo-credit-components/src/bml-display/route.js
// module chunks = 0